import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  value: false,
}

const showCookieSettingsSlice = createSlice({
  name: "showCookieSettings",
  initialState,
  reducers: {
    update: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { update } = showCookieSettingsSlice.actions
export default showCookieSettingsSlice.reducer
